import { EpsParkingRequest } from '../../lib/model/reservation/microapp-eps.parking-request.model';

export class MicroappEpsValidationUtils{
  static readonly OK_STATUS = 'ok';

  static requestIsOK(request: EpsParkingRequest){
    return request.status === this.OK_STATUS && request.available_to_book;
  }
}
